import React from "react";
import { ToastContainer } from "react-toastify";

import { TOASTIFY_CONTAINER_ID } from "constants/toastify";

import "react-toastify/dist/ReactToastify.css";
import "./toastify.scss";

const contextClass = {
    success: "toastify__success",
    error: "toastify__error",
    info: "toastify__info",
    warning: "toastify__warning",
    default: "toastify__default",
    dark: "toastify__dark",
};

const Toastify = () => (
    <ToastContainer
        toastClassName={({ type }) => contextClass[type || "default"] + " toastify"}
        position="top-right"
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        containerId={TOASTIFY_CONTAINER_ID}
    />
);

export default Toastify;
